import { useProfileQuery } from "@/features/profile/api/selectProfile";
import NameForm from "@/features/profile/components/NameForm";
import { ProfileAttributePage, useProfileAttributePage } from "@/features/profile/components/ProfileAttributePage";
import { createFileRoute } from "@tanstack/react-router";

const Name = () => {
    const { auth, copy, goToProfile } = useProfileAttributePage();
    const { data: profile } = useProfileQuery();

    return (
        <ProfileAttributePage title={copy.onboardingNameTitle} description={copy.onboardingNameDescription}>
            <NameForm
                userId={auth.id}
                firstName={profile?.first_name ?? null}
                lastName={profile?.last_name ?? null}
                title={profile?.title ?? null}
                onBack={goToProfile}
                onSuccess={goToProfile}
                primaryLabel={copy.save}
            />
        </ProfileAttributePage>
    );
};

export const Route = createFileRoute("/_app/profile/name")({
    component: Name,
});
